<template>
    <div
        v-if="!isQuizStarted"
        class="flex flex-col items-center w-full h-screen p-4 md:flex-row bg-gradient-to-b from-green-transparent to-white"
    >
        <div class="w-full md:w-auto">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#ffffff"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="fixed cursor-pointer top-4 left-4"
                @click="router.push({ name: 'home' })"
            >
                <path d="m12 19-7-7 7-7" />
                <path d="M19 12H5" />
            </svg>
        </div>
        <div class="w-full md:w-[45%] mt-8 md:mt-0">
            <Card custom>
                <h2
                    class="m-0 text-2xl font-bold text-black"
                    v-if="quiz?.title"
                >
                    {{ quiz.title[locale] }}
                </h2>
                <h2 class="m-0 text-2xl font-bold text-black" v-else>
                    {{ $translate('public.quiz.title') }}
                    {{ $translate('public.quiz.title-2') }}
                </h2>
                <div class="flex flex-col gap-4" v-if="quiz?.description">
                    <p>{{ quiz.description[locale] }}</p>
                </div>
                <div v-else>
                    <p>{{ $translate('public.quiz.text') }}</p>
                    <p>{{ $translate('public.quiz.text-2') }}</p>
                    ?
                </div>
                <button
                    @click="downloadFile()"
                    v-if="quiz.file"
                    class="px-4 py-2 font-bold transition-colors duration-300 rounded-md w-fit border-1 text-green bg-white/80 border-green hover:bg-green hover:text-white"
                >
                    {{ $translate('public.quiz.buttons.1') }}
                </button>
            </Card>
            <div class="flex flex-col items-center justify-center gap-4 mt-8">
                <p class="text-xl font-semibold text-center">
                    {{ $translate('public.quiz.ready') }}
                </p>
                <simple-button @click="startQuiz()">
                    {{ $translate('public.quiz.buttons.2') }}
                </simple-button>
            </div>
        </div>
        <div
            class="flex items-center justify-center w-full h-full md:w-1/2 md:mt-0"
        >
            <img
                src="/storage/assets/images/quiz/question.png"
                alt="Quiz"
                class="object-contain remove_bg_color"
            />
        </div>
    </div>
    <QuizForm :quiz="quiz" v-else-if="isQuizStarted && quiz" :email="email" />
</template>

<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';

import { useApiStore } from '@/js/stores/apiStore';
import { usePopupStore } from '@/js/stores/popupStore';
import { useQuizStore } from '@/js/stores/quizStore';
import { useI18n } from 'vue-i18n';
import Card from './partials/Card.vue';
import QuizForm from './partials/QuizForm.vue';

const apiStore = useApiStore();
const popupStore = usePopupStore();
const quizStore = useQuizStore();

const { locale } = useI18n();

const props = defineProps({
    email: {
        type: String,
        required: true,
    },
});
const quiz = ref({
    title: '',
    description: '',
    file: null,
});
const router = useRouter();
const isQuizStarted = ref(false);
const getQuiz = async () => {
    apiStore
        .apiGet('/api/quiz/' + props.email)
        .then(res => {
            quiz.value = res.quiz;
        })
        .catch(() => {
            popupStore.show('warning', 'Une erreur est survenue.');
            router.push({ name: 'home' });
        });
};

const startQuiz = () => {
    isQuizStarted.value = true;
    quizStore.setUserEmail(props.email);
};

const downloadFile = async () => {
    const filePath = quiz.value?.file;
    if (!filePath) {
        return;
    }

    try {
        const response = await apiStore.apiGet(
            `/api/download/private${filePath}`,
        );

        const { file, mime, name } = response;
        const byteCharacters = atob(file);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: mime });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = name;
        link.click();
    } catch (error) {
        popupStore.show('warning', 'Une erreur est survenue.');
    }
};
await getQuiz();
</script>
